export default "__VITE_ASSET__HhVrUQfT__"